const classtype = {
    state: {
      addClassTypeDialog: {
        title: '新增班级类型信息',
        type: 'add'
      },
      courseTypeList: [],
      courseSearchBtnDisabled: true
    },
    getters: {
      addClassTypeDialog: state => state.addClassTypeDialog,
      courseSearchBtnDisabled: state => state.courseSearchBtnDisabled,
      courseTypeList: state => state.courseTypeList
    },
    mutations: {
      SET_CLASSTYPE_DIALOG_TITLE: (state, type) => {
        console.log("SET_CLASSTYPE_DIALOG_TITLE");
        if (type === 'add') {
          state.addClassTypeDialog.title = '新增班级类型信息'
          state.addClassTypeDialog.type = 'add'
        } else {
          console.log("edit classtype")
          state.addClassTypeDialog.title = '编辑班级类型信息'
          state.addClassTypeDialog.type = 'edit'
        }
      },
      SET_COURSE_SEARCHBTN_DISABLED: (state, payload) => {
        state.courseSearchBtnDisabled = payload;
      },
      SET_COURSE_TYPE_LIST: (state, payload) => {
        state.courseTypeList = payload;
      }
    },
    actions: {
  
    }
  }
  
  export default classtype